import { render, staticRenderFns } from "./bigPackageManageTb.vue?vue&type=template&id=6c984d81&scoped=true"
import script from "./bigPackageManageTb.vue?vue&type=script&lang=js"
export * from "./bigPackageManageTb.vue?vue&type=script&lang=js"
import style0 from "./bigPackageManageTb.vue?vue&type=style&index=0&id=6c984d81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c984d81",
  null
  
)

export default component.exports